import React from "react";

import ReleaseLabel from "../../ReleaseLabel";

import { BasicTooltip } from "@/components/ui/Tooltip";

interface PendingReleaseLabelProps {
  labelName: string;
  labelId: number;
  changelogId: number;
  direction: "incoming" | "outgoing";
  fromVersionNumber: number;
  toVersionNumber: number;
  onClick: (changelogId: number) => void;
}

const PendingReleaseLabel: React.FC<PendingReleaseLabelProps> = ({
  labelName,
  labelId,
  changelogId,
  direction,
  fromVersionNumber,
  toVersionNumber,
  onClick,
}) => {
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    onClick(changelogId);
  };

  const tooltipText =
    direction === "incoming"
      ? `Pending approval: "${labelName}" moving from v${fromVersionNumber}`
      : `Pending approval: "${labelName}" moving to v${toVersionNumber}`;

  return (
    <BasicTooltip content={tooltipText}>
      <div
        className="group/pending relative cursor-pointer"
        onClick={handleClick}
        onMouseDown={e => {
          e.stopPropagation();
        }}
        style={{ pointerEvents: "auto" }}
      >
        <ReleaseLabel
          label={{ id: labelId, name: labelName }}
          variant="pending"
          readOnly={false}
          showDeleteButton={false}
          onClick={() => onClick(changelogId)}
        />
      </div>
    </BasicTooltip>
  );
};

export default PendingReleaseLabel;
